(function() {
  define('scripts',['jquery', 'bootstrap', 'lightgallery', 'lightgalleryFullscreen', 'lightgalleryThumbnail'], function($) {
    var offset, scrollDuration;
    $('.dropdown').hover(function() {
      $(this).children('ul').stop(true, false, true).delay(300).slideDown(300);
      return $(this).addClass('open');
    }, function() {
      $(this).children('ul').stop(true, false, true).slideUp(300);
      return $(this).removeClass('open');
    });
    $('.dropdown-btn.active').next().slideDown(150);
    $('.dropdown-btn').click(function() {
      $('.dropdown-btn').not(this).next().slideUp(150);
      return $(this).next().slideToggle(150);
    });
    $('a.scroll').on('click', function(evt) {
      var target;
      evt.preventDefault();
      target = $(this).attr('href');
      return $('html, body').stop().animate({
        scrollTop: $(target).offset().top - 91
      }, 500);
    });
    $('body').scrollspy({
      target: '#nav-right',
      offset: 92
    });
    if ($('#nav-right').length) {
      $('.nav-right-wrapper').css('min-height', $('.nav-right-wrapper').height() + 10);
      $('#nav-right').affix({
        offset: {
          top: $('#nav-right').offset().top - 91,
          bottom: $('footer').outerHeight(true) + 95
        }
      });
    }
    if ($('#sidebar').length) {
      $('#sidebar').affix({
        offset: {
          top: $('#sidebar').offset().top - 84,
          bottom: $('footer').outerHeight(true) + 95
        }
      });
    }
    if ($('#nav-desktop').length) {
      $('#nav-desktop').affix({
        offset: {
          top: $('#nav-desktop').offset().top,
          bottom: $('footer').outerHeight(true) + 95
        }
      });
      $('#nav-desktop').on('affix.bs.affix', function() {
        if (!$(window).scrollTop()) {
          return false;
        }
      });
    }
    if ($('.menu-button').length) {
      $('.menu-button').affix({
        offset: {
          top: $('.menu-button').offset().top,
          bottom: $('footer').outerHeight(true) + 95
        }
      });
    }
    offset = 250;
    scrollDuration = 800;
    $(window).scroll(function() {
      if ($(this).scrollTop() > offset) {
        return $('.go-top').fadeIn(500);
      } else {
        return $('.go-top').fadeOut(500);
      }
    });
    $('.go-top').click(function(event) {
      event.preventDefault();
      return $('html, body').animate({
        scrollTop: 0
      }, scrollDuration);
    });
    $('.gallery').lightGallery({
      selector: '.item',
      mousewheel: true,
      enableDrag: true,
      exThumbImage: 'data-exthumbimage',
      enableThumbDrag: true,
      download: false,
      enableTouch: true
    });
    $('#cookie-banner-accept').click(function() {
      $('.cookie-banner').hide();
      return $('.copyright.with-cookie-banner').removeClass('with-cookie-banner');
    });
    $('#adsCarousel').carousel({
      interval: 5000
    });
    return $('#search-form').submit(function() {
      var searchValue;
      searchValue = $('#search-value').val();
      return window.open('https://www.qwant.com/?q=site%3Abazemont.fr+' + searchValue);
    });
  });

}).call(this);

//# sourceMappingURL=scripts.js.map
;
